import {
  INSIDER_CART_CHANGED,
  silentCartUpdate,
} from './mod-cart-event-bus.js';
import type { CartChangedDetail } from './mod-cart-event-bus.js';

// Guard distinctUntilChanged — descarta evento se o token não mudou.
// O cart.token é fixo por sessão no Shopify, então, na prática, só persiste uma vez.
let _lastPersistedToken: string | null = null;

async function persistCartId(token: string): Promise<void> {
  if (token === _lastPersistedToken) return;

  // Seta antes do await para evitar race condition:
  // se um segundo evento chegar antes do fetch completar, cai no guard acima.
  _lastPersistedToken = token;
  console.debug(`[cart-attribute-tracker] persist cartId: ${token}`);

  try {
    await silentCartUpdate({ attributes: { _cartId: token } });
  } catch (err) {
    // Reverte em caso de erro para permitir nova tentativa
    _lastPersistedToken = null;
    console.warn('[cart-attribute-tracker] Failed to persist cartId:', err);
  }
}

document.addEventListener(INSIDER_CART_CHANGED, (e: Event) => {
  const { cart } = (e as CustomEvent<CartChangedDetail>).detail;
  if (cart?.token) persistCartId(cart.token);
});
